module.exports = __webpack_public_path__ + "img/how-to-negotiate.5b63437.jpg";